import './App.css';
import { BrowserRouter, Routes, Route /*, useSearchParams */ } from "react-router-dom";
import MarketingForm from './components/MarketingForm/MarketingForm';
import CodeForm from './components/CodeForm/CodeForm';
import Header from './components/Header/Header';


const App = () => {
  return (
    <div className="App">
      <Header />
      <BrowserRouter>
        <Routes>
          <Route path="/">
            <Route path="welcome/:codeParam" element={<MarketingForm />} />
            <Route path="code" element={<CodeForm />} >
              <Route path=":codeParam" element={<CodeForm />} />
            </Route>
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;

